var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"box-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.goDes(item.id)}}},[_vm._v(_vm._s(item.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }